import { Stack, StackProps } from '@mui/material'
import { omit } from 'lodash'
import { PropsWithChildren } from 'react'

import FormatCell, { FormatCellProps, FormatCellType } from '#/components/FormatCell'
import { formatCellAllowProps } from '#/components/FormatCell/allowProps'

/**
 * Item de `multi-data`. Não pode referenciar `FormatCellProps` diretamente, pois
 * `multi-data` é um dos renderers registrados — isso criaria uma referência
 * circular na união discriminada. Usamos apenas o discriminante `type`.
 */
type MultiDataItem = { type: FormatCellType } & Record<string, any>

type Props = { value: MultiDataItem[] } & StackProps

const TypeMultiData = ({ children, value, ...rest }: PropsWithChildren<Props>) => {
  if (!value) return <>-</>

  return (
    <Stack
      direction="row"
      spacing={2}
      {...omit(rest, formatCellAllowProps)}
      sx={{ alignItems: 'center' }}
    >
      {value?.map((props, index) => {
        const cellProps = { value: props, ...props } as FormatCellProps
        return <FormatCell key={`${props.type}-${index}`} {...cellProps} />
      })}
      {children}
    </Stack>
  )
}
export default TypeMultiData
